var map = {
	"./Dr.C.Rangasami.jpeg": 92021,
	"./Dr.D.Ramarajan.jpeg": 43124,
	"./Dr.K.Maheshvaran.JPG": 70592,
	"./Dr.K.Prabu.jpeg": 36654,
	"./Dr.M.Malathi.jpg": 63051,
	"./Dr.N.Poongodi.jpeg": 97642,
	"./Dr.N.Srinivasan.jpeg": 68245,
	"./Dr.S.B.Tharchanaa.jpeg": 26123,
	"./Dr.S.Kiruthika.jpg": 20105,
	"./Dr.S.Sudha.jpeg": 80937,
	"./Mr.V.Parthibaraj.jpg": 73151,
	"./Ms.C.Karthika.jpeg": 14329,
	"./Ms.D.Shobana.jpg": 16176,
	"./mariyappan.jpg": 16370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20098;